module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "toctitle"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Preface"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Preface")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Hugh"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Hugh John Lambert (1937–2016)")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Publisher"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Publisher’s Note")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Part01"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Part One: The First World War")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("1:")]), _vm._v(" A Change of Strategy")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Chapter02"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("2:")]), _vm._v(" Cometh the Hour, Cometh the Men")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("3:")]), _vm._v(" Materiel")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("4:")]), _vm._v(" Fishing for Mines")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("5:")]), _vm._v(" Fishing for Submarines")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("6:")]), _vm._v(" General Duties")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("7:")]), _vm._v(" Life on Board")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("8:")]), _vm._v(" Fishing Heroes and Memory")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Part02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Part Two:  The Second World War")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("9:")]), _vm._v(" Between the Wars, 1919–1939")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("10:")]), _vm._v(" Of Men and Ships")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("11:")]), _vm._v(" Keeping the Seas – Anti-Submarine Warfare")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("12:")]), _vm._v(" New Threats from the Air and the Sea")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("13:")]), _vm._v(" Clearing the Way – Minesweeping")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("14:")]), _vm._v(" Convoy")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("15:")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("In Imis Petimus")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("16:")]), _vm._v(" Heroes and Memorials")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocn"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Chapter16a",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Envoi")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter16b",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("THE PLANS")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("First World War")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc0"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter16b#p1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I "), _c('span', {
    staticClass: "r"
  }, [_c('span', {
    staticClass: "smallcap"
  }, [_vm._v("HM")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Strath")]), _vm._v("-class Admiralty trawler, general arrangement, 1917")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc0"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter16b#p2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II "), _c('span', {
    staticClass: "r"
  }, [_c('span', {
    staticClass: "smallcap"
  }, [_vm._v("HM")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Strath")]), _vm._v("-class Admiralty trawler, hull lines and detail, 1917")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc0"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter16b#p3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III "), _c('span', {
    staticClass: "r"
  }, [_c('span', {
    staticClass: "smallcap"
  }, [_vm._v("HM")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Castle")]), _vm._v("-class Admiralty standard trawler, general arrangement, 1917")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc0"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter16b#p4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV "), _c('span', {
    staticClass: "r"
  }, [_c('span', {
    staticClass: "smallcap"
  }, [_vm._v("HM")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Mersey")]), _vm._v("-class Admiralty trawler, general arrangement, 1917")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc0"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter16b#p5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V "), _c('span', {
    staticClass: "r"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Ocean-class")]), _vm._v(" Admiralty steel screw steam drifter, 1917–18")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc0"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter16b#p6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI "), _c('span', {
    staticClass: "r"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Ocean")]), _vm._v("-class Admiralty steel screw steam drifter, general arrangement, 1917")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc0"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter16b#p7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII "), _c('span', {
    staticClass: "r"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Ocean")]), _vm._v("-class steel screw steam drifter, rigging plan and sheer drawing,1917")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc0"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter16b#p8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII "), _c('span', {
    staticClass: "r"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Ocean")]), _vm._v("-class steel screw steam drifter, modifications required for vessels to work as fishing drifters, 1918")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc0"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter16b#p9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX "), _c('span', {
    staticClass: "r"
  }, [_vm._v("QF 3in 12pdr on Mark V pedestal mounting; QF 3in 12pdr on Mark VI pedestal mounting")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc0"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter16b#p10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X "), _c('span', {
    staticClass: "r"
  }, [_vm._v("A First World War Hotchkiss 6pdr on a non recoil 1941 mounting")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Second World War")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc0"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter16b#p11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI "), _c('span', {
    staticClass: "r"
  }, [_c('span', {
    staticClass: "smallcap"
  }, [_vm._v("HM")]), _vm._v(" trawler "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Quannet")]), _vm._v(" (ex-"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Dairycoats")]), _vm._v("), ‘Tree’-class, general arrangement, converted to a boom defence vessel, May 1939")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc0"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter16b#p12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII "), _c('span', {
    staticClass: "r"
  }, [_c('span', {
    staticClass: "smallcap"
  }, [_vm._v("HM")]), _vm._v(" trawler "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Laurel")]), _vm._v(" (ex-"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Kingston Cyanite")]), _vm._v("), ‘Tree’-class, purchased 1935")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc0"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter16b#p13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII "), _c('span', {
    staticClass: "r"
  }, [_vm._v("The Admiralty’s ‘ideal’ trawler "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Basset")]), _vm._v(", 1936 programme")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc0"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter16b#p14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIV "), _c('span', {
    staticClass: "r"
  }, [_vm._v("Admiralty anti-submarine and minesweeping trawlers of the ‘Isles’ and ‘Shakespearian’-classes, sheer lines and shell expansion, 1939")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc0"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter16b#p15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XV "), _c('span', {
    staticClass: "r"
  }, [_c('span', {
    staticClass: "smallcap"
  }, [_vm._v("HM")]), _vm._v(" trawler "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Lindisfarne")]), _vm._v(", Admiralty war construction ‘Isles’-class")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc0"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter16b#p16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XVI "), _c('span', {
    staticClass: "r"
  }, [_vm._v("Detail and general layout of the ‘Round Table’-class minesweeping trawler")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc0"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter16b#p17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XVII "), _c('span', {
    staticClass: "r"
  }, [_vm._v("The ‘Round Table’-class minesweeping trawler "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sir Galahad")])])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc0"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter16b#p18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XVIII "), _c('span', {
    staticClass: "r"
  }, [_c('span', {
    staticClass: "smallcap"
  }, [_c('span', {
    staticClass: "smallcap"
  }, [_vm._v("HM")]), _vm._v("S")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Coldstreamer")]), _vm._v(", ‘Military’-class A/S trawler, 1942")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc0"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter16b#p19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIX "), _c('span', {
    staticClass: "r"
  }, [_vm._v("Profile "), _c('span', {
    staticClass: "smallcap"
  }, [_vm._v("HM")]), _vm._v(" anti-submarine trawler "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Thuringia")]), _vm._v(", as converted, 1939")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc0"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter16b#p20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XX "), _c('span', {
    staticClass: "r"
  }, [_c('span', {
    staticClass: "smallcap"
  }, [_vm._v("HM")]), _vm._v(" anti-submarine trawler "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Thuringia")]), _vm._v(", as converted, 1939. Galley top, boat platform and wheelhouse")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc0"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter16b#p21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XXI "), _c('span', {
    staticClass: "r"
  }, [_vm._v("Decks "), _c('span', {
    staticClass: "smallcap"
  }, [_vm._v("HM")]), _vm._v(" anti-submarine trawler "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Thuringia")]), _vm._v(", as converted, 1939")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc0"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter16b#p22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XXII "), _c('span', {
    staticClass: "r"
  }, [_vm._v("The ‘Round Table’-class trawler "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sir Kay")]), _vm._v(", as modified for influence (acoustic & magnetic) minesweeping")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc0"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter16b#p23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XXIII "), _c('span', {
    staticClass: "r"
  }, [_c('span', {
    staticClass: "smallcap"
  }, [_vm._v("HM")]), _vm._v(" trawlers "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Bryher")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Farne")]), _vm._v(" (danlaying conversion) ‘Isles’-class, 1943")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc0"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter16b#p24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XXIV "), _c('span', {
    staticClass: "r"
  }, [_vm._v("Anti-submarine trawlers "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("St Apollo")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("St Zeno")])])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc0"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter16b#p25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XXV "), _c('span', {
    staticClass: "r"
  }, [_vm._v("Details of trawler design; Oropesa sweep and davits")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc0"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter16b#p26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XXVI "), _c('span', {
    staticClass: "r"
  }, [_vm._v("6pdr Hotchkiss QF gun HA/LA Mark VI on a Second World War mounting, 1942")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc0"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter16b#p27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XXVII "), _c('span', {
    staticClass: "r"
  }, [_vm._v("20mm Oerlikon gun on Mark I, IIA, VIIA & VIIIA mountings, as extensively fitted to the armed trawlers")]), _vm._v(".")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc0"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter16b#p28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XXVIII "), _c('span', {
    staticClass: "r"
  }, [_vm._v("3pdr Hotchkiss gun on the Mark I, I* 50° conversion, Mark V, VI, VI* mountings, 1942")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc0"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter16b#p29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XXIX "), _c('span', {
    staticClass: "r"
  }, [_vm._v("The Holman projector Marks II 1940, IIA & IIS 1941 & III of 1943")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc0"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter16b#p30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XXX "), _c('span', {
    staticClass: "r"
  }, [_vm._v("The 14ft 6in Admiralty drifter type boat")])])]), _vm._v(" "), _c('h2', {
    staticClass: "tock"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Appendix",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Appendices")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Appendix#appx_1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("1.")]), _vm._v(" Types of Mines in 1914")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Appendix#appx_2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("2.")]), _vm._v(" An Example of the Text of a 1914 T-124 Form")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Appendix#appx_3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("3.")]), _vm._v(" Admiralty Trawlers 1914–1918")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Appendix#appx_4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("4.")]), _vm._v(" Admiralty Drifters 1914–1918")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Appendix#appx_5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("5.")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Strath")]), _vm._v("-, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Mersey")]), _vm._v("- and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Castle-")]), _vm._v("class Trawlers")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Appendix#appx_6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("6.")]), _vm._v(" Total Trawler and Drifter Losses by Cause, 1914–1918")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Appendix#appx_7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("7.")]), _vm._v(" Admiralty-built Trawlers in the Second World War")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Appendix#appx_8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("8.")]), _vm._v(" Trawlers and Drifters Sunk at Dunkirk")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Appendix#appx_9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("9.")]), _vm._v(" Trawlers Sent to Aid the US Navy in 1942")])]), _vm._v(" "), _c('h2', {
    staticClass: "tock"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/29_Sources",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Sources")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Bibliography")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a01b224c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/toc.vue
// module id = 69
// module chunks = 0